import React, {Component} from 'react';
import { Link } from 'react-router-dom';


const CollapsableItem = ({title, isCollapsed, renderBody, extraLink, onToggleBody}) => {

  return (
    <div className="collapsable-item">
      <div className="collapsable-item-header">
        <div className="collapsable-item-title">{title}</div>
        <div className="collapsable-item-toggle-button"
          onClick={() => onToggleBody ? onToggleBody() : null}>
          {isCollapsed ? (
            <i className="fa fa-plus-square-o" />
          ) : (
            <i className="fa fa-minus-square-o" />
          )}
        </div>
      </div>
      {isCollapsed ? null : (
        <div className="collapsable-item-body">
          {renderBody ? renderBody() : null}
          {renderExtraLink()}
        </div>
      )}
    </div>
  )

  function renderExtraLink() {

    const {text, action} = extraLink ? extraLink : {};
    return extraLink ? (
      <div
        className="extra-link"
        onClick={() => extraLink.action ? extraLink.action() : null}>
          { extraLink.text ? extraLink.text : 'View All'}
        </div>
    ) : null
  }
}

export default CollapsableItem;



// WEBPACK FOOTER //
// ./src/components/commons/collapsable-item/CollapsableItem.js